<script setup lang="ts">
const props = withDefaults(defineProps<{
  title: string
  cta?: string
  iconName?: string
  size?: 'normal' | 'small'
  theme?: Partial<{
    titleColor: string
    titleSize: string
    iconColor: string
    iconSize: string
    ctaColor: string
    ctaSize: string
  }>
}>(), {
  size: 'normal',
})

const minHeight = computed(() => {
  return props.size === 'normal' ? '20vh' : '5vh'
})
</script>

<template>
  <div :class="`grid place-content-center border border-dashed rounded-sm p-6 min-h-[${minHeight}]`">
    <div class="text-center">
      <Icon
        v-if="iconName"
        :name="iconName"
        :size="theme?.iconSize ?? '35px'"
        :class="theme?.iconColor ?? 'text-hos-blue-dark'"
      />
      <p
        class="font-semibold"
        :class="[theme?.titleSize ?? 'text-xl md:text-2xl', theme?.titleColor ?? 'text-hos-blue-dark']"
      >
        {{ title }}
      </p>
      <p
        v-if="cta"
        class="mt-1 md:mt-0"
        :class="[theme?.ctaSize ?? 'text-sm', theme?.ctaColor ?? 'text-hos-blue']"
      >
        {{ cta }}
      </p>
      <slot />
    </div>
  </div>
</template>
